<template>
  <div class="schedule" id="schedule">
    <div class="banner ban_title">
      <h1 class="h1">大会日程<ppt-manage v-if="pptMLimit"
      class="mob" :placement="'bottom'" :ispack="true" @manage="getPPTManage" @link="getPPTLink"></ppt-manage></h1>
      <!-- <p class="p" v-if="periods&&periods[0]&&time">{{ getCourseLength() }}个国内外AI最佳落地实践案例</p> -->
      <!-- <p class="p" v-else>{{ id_list['opening'] ? 66 : 84 }}个国内外AI最佳落地实践案例</p> -->
    </div>
    <div class="pc_content">
      <div class="con schedule_con" v-if="!(scheduleData && global.isObjectKeys(scheduleData))">
        <p class="schedule_null">{{ tips }}</p>
      </div>
      <div class="con schedule_con" v-else>
        <!-- 页角导航 -->
        <div id="menu" :class="`pc ${pptMLimit?'has-ppt-goods':''}`" style="display: none">
          <ul>
            <li v-for="(item,index) in days" :key="'menu_li_'+item">
              <a @click.prevent="clickLi_(index)" :class="pday==index?'dianji current':'dianji'"
              >DAY{{index+1}}</a>
            </li>
          </ul>
        </div>
        <div class="menu pc" v-if="pptMLimit">
          <ppt-manage :ispack="true" @manage="getPPTManage" @link="getPPTLink"></ppt-manage>
        </div>
        <!-- 日程 pc -->
        <div class="richeng pc">
          <!-- 导航 -->
          <ul class="daohang">
            <li v-for="(item, index) in days" :key="'daohang_' + index"
                :class="pday == index ? 'active col-lg-4 col-md-4 col-sm-4' : 'col-lg-4 col-md-4 col-sm-4'">
              <a class="dianji" @click.prevent="clickLi_(index)">
                <div>
                  <h1>DAY{{ index + 1 }}</h1>
                  <span>{{ global.formatTime(item,'Y.M.D') }} {{ global.getWeek(item) }}</span>
                </div>
              </a>
            </li>
          </ul>
          <!-- 日程 -->
          <ul class="content content_spc" v-if="scheduleDataValid">
            <li v-for="(scheduledata, day, index) in scheduleData" :key="'days_'+index" class="show" :id="'item'+(index+1)">
              <h4>DAY{{index+1}}</h4>
              <table :style="`--group-length: ${groupLength[index]};`">
                <tbody>
                  <slot v-for="(list, period) in scheduledata">
                    <!-- 开幕式 -->
                    <slot v-if="isOpening(index,period)">
                      <tr class="top" :class="`s-${sid}`" :key="`top_${index}_${period}`">
                        <td class="time-title" valign="middle" align="center">
                          <a>
                            <span class="fenhuichang">分会场</span>
                            <span class="line"></span>
                            <span class="shijian">时间</span>
                          </a>
                        </td>
                        <td class="opening-title" valign="middle" align="center" :colspan="groupLength[0]"
                        >开幕式<button class="tolive" v-if="liveMarkOpeningEnter" @click="goLive"
                        >进入直播间</button><el-tooltip placement="bottom" v-else-if="liveMarkOpeningShow"
                        ><div slot="content" class="tolive-code">
                          <div class="qrcode-wrapper">
                            <div class="wechat-wrapper">
                              <img src="https://f.msup.com.cn/live-wechat-logo.png" alt="" class="wechat-logo">
                              微信扫码
                            </div>
                            <img src="https://f.msup.com.cn/msup_offcial_qrcode.jpg" alt="" class="code">
                            <div class="text">{{ liveMarkOpeningMsg }}</div>
                          </div>
                        </div><el-button class="tolive tool-tip"
                        >进入直播间</el-button></el-tooltip></td>
                      </tr>
                      <tr class="kecheng opening" v-for="(opitem,opindex) in opening" :key="`kecheng_${index}_${period}_${opindex}`">
                        <td v-if="opitem.desc.includes(',')">{{
                          global.formatHoure(opitem.desc.split(',')[0])
                        }}<br>-<br>{{
                          global.formatHoure(opitem.desc.split(',')[1])
                        }}</td>
                        <td v-else-if="opitem.desc.includes('，')">{{
                          global.formatHoure(opitem.desc.split('，')[0])
                        }}<br>-<br>{{
                          global.formatHoure(opitem.desc.split('，')[1])
                        }}</td>
                        <td valign="top" align="left" :colspan="groupLength[index]" class="course-href">
                          <div class="biaoti_s">{{opitem.content_note}}</div>
                          <slot v-if="opitem.content&&opitem.content!=''">
                            <div class="ren" v-for="(opcitem,opcindex) in opitem.content.split('||')" :key="'opc'+opcindex">
                              <h2 v-html="opcitem.split('|')[0]"></h2>
                              <p v-html="opcitem.split('|')[1]"></p>
                            </div>
                          </slot>
                        </td>
                      </tr>
                      <!-- <tr class="kecheng opening" v-for="(opitem,opindex) in openingList" :key="`kecheng_${index}_${period}_${opindex}`">
                        <td v-if="opitem.times">{{ opitem.times[0] }}<br>-<br>{{ opitem.times[1] }}</td>
                        <td valign="top" align="left" :colspan="groupLength[index]" class="course-href">
                          <div class="biaoti_s">{{opitem.title}}</div>
                          <slot v-if="opitem.lecturer&&Array.isArray(opitem.lecturer)">
                            <div class="ren" v-for="(opcitem,opcindex) in opitem.lecturer" :key="'opc'+opcindex">
                              <h2 v-html="opcitem.split('|')[0]"></h2>
                              <p v-html="opcitem.split('|')[1]"></p>
                            </div>
                          </slot>
                        </td>
                      </tr> -->
                      <tr class="kecheng opening" v-if="!opening || !opening.length" :key="`kecheng_${index}_${period}_`">
                        <td>09:00<br>-<br>12:00</td>
                        <td valign="middle" align="center" :colspan="groupLength[index]" class="course-href blank">敬请期待</td>
                      </tr>
                    </slot>
                    <!-- 课程 -->
                    <slot v-else>
                      <!-- top -->
                      <tr class="top" :class="`s-${sid}`" :key="`top_c_${index}_${period}`">
                        <td class="time-title" valign="middle" align="center">
                          <a>
                            <span class="fenhuichang">分会场</span>
                            <span class="line"></span>
                            <span class="shijian">时间</span>
                          </a>
                        </td>
                        <td v-for="(groupid) in groupLength[index]" :key="`top_c_${index}_${period}_${groupid}`">
                          <a @click="toSubjectDetail(finishingData[day][groupid+period])">
                            <p class="group-name">{{ finishingData[day][groupid+period].name || '敬请期待' }}</p>
                            <slot v-if="sid!=='4288' && Array.isArray(finishingData[day][groupid+period].producers) && finishingData[day][groupid+period].producers.length>1">
                              <span class="chup">出品人：</span>
                              <span class="chup company" v-for="(value, vindex) in finishingData[day][groupid+period].producers" :key="`chup_${index}_${period}_${groupid}_${value}`"
                              >{{ value }} {{ finishingData[day][groupid+period].company[vindex] || '' }} {{ finishingData[day][groupid+period].position[vindex] || '' }}</span>
                            </slot>
                            <slot v-else-if="sid!=='4288'">
                              <span class="chup">出品人：{{
                                checkProducers(finishingData[day][groupid+period].producers) || '大咖正在就位'
                              }}</span>
                              <span class="chup company">{{
                                checkProducers(finishingData[day][groupid+period].company) || '' }} {{
                                checkProducers(finishingData[day][groupid+period].position) || ''
                              }}</span>
                            </slot>
                          </a>
                        </td>
                      </tr>
                      <!-- kecheng -->
                      <slot v-for="(group, time, timeIndex) in list">
                        <tr class="kecheng" v-if="!(sid==4886 && index==1 && timeIndex==3 && '16:00'<time)" :key="`kecheng_c_${index}_${period}_${time}`">
                          <td v-if="sid==4886 && index==1 && timeIndex==2 && '15:00'<time">15:30<br>-<br>16:30</td>
                          <td v-else>{{ global.formatHoure(group['time'][0]) }}<br>-<br>{{ global.formatHoure(group['time'][1]) }}</td>
                          <slot v-for="(course, groupid) in group">
                            <slot v-if="groupid!=='time'">
                              <!-- 特殊排课 -->
                              <slot v-if="scheduleDifference && scheduleDifference[getGroupKey(index, groupid, period)] && scheduleDifference[getGroupKey(index, groupid, period)].courses && scheduleDifference[getGroupKey(index, groupid, period)].courses.length > 0">
                                <td class="course-href difference" valgin="top" :rowspan="Object.keys(list).length" v-if="timeIndex===0" :key="`kecheng_c_d_${index}_${period}_${time}_${groupid}`">
                                  <!-- {{ `${year}_${parseInt(index)+1}_${groupid}_${period}` }} -->
                                  <table class="d-con">
                                    <tbody>
                                      <tr class="d-item link-url" v-if="scheduleDifference[getGroupKey(index, groupid, period)].linkUrl">
                                        <td class="d-item-detail course-href">
                                          <a :href="scheduleDifference[getGroupKey(index, groupid, period)].linkUrl" target="_blank">点击报名本专场</a>
                                        </td>
                                      </tr>
                                      <tr class="d-item" v-for="(course, courseIndex) in scheduleDifference[getGroupKey(index, groupid, period)].courses" :key="`kecheng_c_d_${index}_${period}_${time}_${groupid}_${courseIndex}`">
                                        <td class="d-item-detail course-href">
                                          <!-- {{ course.times }} -->
                                          <a v-if="course.courseId" :href="formatHref('/course', {sid, cid:course.courseId, vid:reVenueId(finishingData[day][groupid+period].name), dif:1, source:sid=='4488'?encodeURIComponent('腾讯云'):''})" target="_blank">
                                            <div class="biaoti_s">{{ course.courseTitle || '' }}</div>
                                            <slot v-if="course.lecturers && course.lecturers.length>0">
                                              <div class="ren" v-for="(lecturer, lindex) in course.lecturers" :key="`lecturer_c_${index}_${period}_${time}_${groupid}_${lindex}_${lecturer.lid||''}`">
                                                <h2>{{ lecturer.name }}</h2>
                                                <p>{{ lecturer.company }}<br>{{ lecturer.position }}</p>
                                              </div>
                                            </slot>
                                          </a>
                                          <a v-else>
                                            <div class="biaoti_s">{{ course.courseTitle || '' }}</div>
                                            <slot v-if="course.lecturers && course.lecturers.length>0">
                                              <div class="ren" v-for="(lecturer, lindex) in course.lecturers" :key="`lecturer_c_${index}_${period}_${time}_${groupid}_${lindex}_${lecturer.lid||''}`">
                                                <h2>{{ lecturer.name }}</h2>
                                                <p>{{ lecturer.company }}<br>{{ lecturer.position }}
                                                </p>
                                              </div>
                                            </slot>
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </slot>
                              <!-- 正常排课 -->
                              <slot v-else>
                                <td v-if="course&&course.courseId" valign="top" align="left" class="course-href" :key="`kecheng_c_${index}_${period}_${time}_${groupid}`">
                                  <a :href="formatHref('/course', {sid, cid:course.courseId})" target="_blank">
                                    <div class="biaoti_s">{{ course.courseTitle || '' }}</div>
                                    <slot v-if="course.lecturers && course.lecturers.length>0">
                                      <div class="ren" v-for="(lecturer, lindex) in course.lecturers" :key="`lecturer_${index}_${period}_${time}_${groupid}_${lindex}_${lecturer.lid||''}`">
                                        <h2>{{ lecturer.name }}</h2>
                                        <p>{{ lecturer.company }}<br>{{ lecturer.position }}</p>
                                      </div>
                                    </slot>
                                  </a>
                                  <div :class="checkCourseTime(day, group['time'], course.pptStatus)">
                                    <i>PPT</i>
                                  </div>
                                </td>
                                <td v-else valign="middle" align="center" class="course-href blank" :key="`kecheng_${index}_${period}_${time}_${groupid}`">
                                  <a>敬请期待</a>
                                </td>
                              </slot>
                            </slot>
                          </slot>
                        </tr>
                      </slot>
                    </slot>
                  </slot>
                </tbody>
              </table>
            </li>
          </ul>
        </div>
        <!-- 日程 mob -->
        <div class="richeng mob">
          <!-- 导航 -->
          <ul class="daohang col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <slot v-for="(scheduledata, day, index) in scheduleData">
              <li v-for="(list, period) in scheduledata" :class="`${colClass(3)} ${(mday==index&&mperiod==period)?'active':''}`" :key="`day_mob_${index}_${period}`">
                <a class="dianji" @click="showDay(index,period)">
                  <h1>DAY{{ index + 1 }} <span>{{period=='am'?'上午':'下午'}}</span> </h1>
                </a>
              </li>
            </slot>
          </ul>
          <div class="clearfix"></div>
          <div class="content content_smob">
            <!-- 专题 -->
            <ul class="day_menu">
              <slot v-if="isOpening(mday,mperiod)">
                <slot v-if="liveMarkOpeningEnter">
                  <li :class="`${courses_index==-1?'active':''} li_havelive_op`" @click="showCourses(-1)"
                  ><h1>开幕式</h1><p v-if="openingAddress"><i class="glyphicon glyphicon-map-marker"></i>{{ openingAddress }}</p></li>
                  <li><button class="tolive_mob" @click="goLive"
                  >进入直播间</button></li>
                </slot>
                <slot v-else-if="liveMarkOpeningShow">
                  <li :class="`${courses_index==-1?'active':''} li_havelive_op`" @click="showCourses(-1)"
                  ><h1>开幕式</h1><p v-if="openingAddress"><i class="glyphicon glyphicon-map-marker"></i>{{ openingAddress }}</p></li>
                  <li style="padding: 0;"><el-tooltip placement="bottom"><div slot="content" class="tolive-code">
                    <div class="qrcode-wrapper">
                      <div class="wechat-wrapper">
                        <img src="https://f.msup.com.cn/live-wechat-logo.png" alt="" class="wechat-logo">
                        微信扫码
                      </div>
                      <img src="https://f.msup.com.cn/msup_offcial_qrcode.jpg" alt="" class="code">
                      <div class="text">{{ liveMarkOpeningMsg }}</div>
                    </div>
                  </div><el-button class="tolive_mob">进入直播间</el-button></el-tooltip></li>
                </slot>
                <slot v-else>
                  <li :class="`${courses_index==-1?'active':''}`" @click="showCourses(-1)"
                  ><h1>开幕式</h1><p v-if="openingAddress"><i class="glyphicon glyphicon-map-marker"></i>{{ openingAddress }}</p></li>
                </slot>
              </slot>
              <slot v-else-if="groupLength && groupLength[0]">
                <slot v-for="(groupid) in groupLength[0]">
                  <li
                    v-if="finishingData[days[mday]][groupid+mperiod]"
                    @click="showCourses(groupid)"
                    :class="courses_index==groupid?'active':''"
                    :key="`day_mob_${sid}_${mday}_${mperiod}_${groupid}`"
                  ><h1>{{
                    finishingData[days[mday]][groupid+mperiod].name || '敬请期待'
                  }}</h1><p v-if="finishingData[days[mday]][groupid+mperiod].groupName && !finishingData[days[mday]][groupid+mperiod].groupName.includes('分组')"
                  ><i class="glyphicon glyphicon-map-marker"></i>{{
                    finishingData[days[mday]][groupid+mperiod].groupName
                  }}</p></li>
                </slot>
              </slot>
            </ul>
            <div class="clearfix"></div>
            <!-- 课程 -->
            <ul class="day_list opening" v-if="isOpening(mday,mperiod)&&courses_index==-1">
              <li v-for="(m_op,m_op_i) in opening" :key="'mob_opening_'+m_op_i">
                <h1 v-html="m_op.content_note"></h1>
                <p v-if="m_op.content&&m_op.content!=''">
                  <span v-html="m_op.content.split('|')[0]"></span>
                  <slot v-if="m_op.content.split('|')[1]">{{ m_op.content.split('|')[1] }}</slot>
                  <slot v-else>{{ m_op.content.split(',')[1] }}</slot>
                </p>
                <p v-if="m_op.desc&&m_op.desc!=''">
                  <span class="glyphicon glyphicon-time"></span>
                  {{ global.formatTime(days[0],'Y.M.D') }}
                  <slot v-if="m_op.desc.includes(',')">{{ global.formatHoure(m_op.desc.split(',')[0]) }}</slot>
                  <slot v-else-if="m_op.desc.includes('，')">{{ global.formatHoure(m_op.desc.split('，')[0]) }}</slot>
                </p>
              </li>
            </ul>
            <ul class="day_list" v-else-if="scheduleData[days[mday]] && scheduleData[days[mday]][mperiod]">
              <!-- 特殊排课 -->
              <slot v-if="scheduleDifference && scheduleDifference[getGroupKey(mday, courses_index, mperiod)] && scheduleDifference[getGroupKey(mday, courses_index, mperiod)].courses && scheduleDifference[getGroupKey(mday, courses_index, mperiod)].courses.length > 0">
                <slot v-for="(group, time) in scheduleDifference[getGroupKey(mday, courses_index, mperiod)].courses">
                  <li class="difference" v-if="group && typeof group=='object'" :key="`course_${mday}_${mperiod}_${time}_${courses_index}`">
                    <a v-if="group.courseId" :href="formatHref('/course', {sid, cid:group.courseId, vid:reVenueId(finishingData[mday][courses_index+mperiod].name), dif:1, source:sid=='4488'?encodeURIComponent('腾讯云'):''})" target="_blank">
                      <h1>{{ group.courseTitle }}</h1>
                      <p v-for="(lecturer, lindex) in group.lecturers" :key="`lecturer_${mday}_${mperiod}_${time}_${courses_index}_${lindex}`">
                        <span>{{ lecturer.name }}</span>
                        {{ lecturer.company }}&nbsp;&nbsp;&nbsp;{{ lecturer.position }}
                      </p>
                    </a>
                    <a v-else>
                      <h1>{{ group.courseTitle }}</h1>
                      <p v-for="(lecturer, lindex) in group.lecturers" :key="`lecturer_${mday}_${mperiod}_${time}_${courses_index}_${lindex}`">
                        <span>{{ lecturer.name }}</span>
                        {{ lecturer.company }}&nbsp;&nbsp;&nbsp;{{ lecturer.position }}
                      </p>
                    </a>
                  </li>
                </slot>
              </slot>
              <!-- 正常排课 -->
              <slot v-else>
                <slot v-for="(group, time) in scheduleData[days[mday]][mperiod]">
                  <li v-if="group[courses_index] && typeof group[courses_index]=='object'" :key="`course_${mday}_${mperiod}_${time}_${courses_index}`">
                    <a :href="formatHref('/course', {sid, cid:group[courses_index].courseId})" target="_blank">
                      <h1>{{ group[courses_index].courseTitle }}</h1>
                      <p v-for="(lecturer, lindex) in group[courses_index].lecturers" :key="`lecturer_${mday}_${mperiod}_${time}_${courses_index}_${lindex}`">
                        <span>{{ lecturer.name }}</span>
                        {{ lecturer.company }}&nbsp;&nbsp;&nbsp;{{ lecturer.position }}
                      </p>
                      <p>
                        <span class="glyphicon glyphicon-time"></span>
                        {{ global.formatTime(days[mday],'Y.M.D') }} {{ global.formatHoure(group.time[0]) }}
                        <span :class="checkCourseTime(days[mday], group.time, group[courses_index].pptStatus)"><i>PPT</i></span>
                      </p>
                    </a>
                  </li>
                </slot>
              </slot>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from "jquery"
import { mixinSession } from '../mixin'

export default {
  name: 'Schedule',
  mixins: [mixinSession],
  components: {
    pptManage: () => import('../componentsNew/CoursePPTTicket.vue')
  },
  data () {
    return {
      tips: '加载中···', // 敬请期待
      /* time */
      // theTime: new Date('2024/06/28').getTime(),
      theTime: new Date().getTime(),
      // firstDay: 0,
      // firstTime: 0,
      /* param */
      pday: 0, // pc端当前天数
      mday: 0, // mob端当前天数
      mperiod: 'am', // mob端当前时段 am/pm
      courses_index: 1, // mob端当前专题（专题从1开始，开幕式为-1）
      /* data */
      sid: '', // 大会id
      year: '', // 年份
      days: [], // 日期数组
      // time: [], // 每日时间
      periods: [], // 每日专题及时段数组 am*pm
      groupLength: [], // 每日半日专题数数组
      subject: [], // 专题列表
      schedule: {}, // 日程+专题+每日时间
      scheduleData: {}, // 日程
      finishingData: {}, // 专题
      scheduleDataValid: false, // 日程是否有效
      recommend: [], // 推荐课程
      opening: '', // 开幕式安排
      openingList: '',
      openingAddress: '',
      scheduleDifference: {}, // 特殊日程
      liveMark: false,
      // liveMarkOpeningEnter: false,
      // liveMarkOpeningShow: false,
      // liveMarkOpeningMsg: '预约观看现场直播',
      pptGoodsId: '',
      pptLink: '',
      collectionInfos: {}
    }
  },
  computed: {
    pptMLimit () { // 是否启用ppt下载(打包下载)
      // return true
      return Boolean(this.theTime >= (this.lastDay + 2 * this.global.timestamp)) // 会后2天后启用
      // return this.$route.query && this.$route.query.ppt
    },
    // days () {
    //   return ((this.schedule.datas && Object.keys(this.schedule.datas)) || []).sort() // 日期数组
    // },
    time () {
      return (this.schedule.timesData && Object.keys(this.schedule.timesData)) || [] // 每日课程时间数组
    },
    firstDay () {
      if (this.days[0]) {
        let y = new Date(this.days[0] * 1000).getFullYear()
        let m = new Date(this.days[0] * 1000).getMonth()
        let d = new Date(this.days[0] * 1000).getDate()
        return new Date(y, m, d, 0, 0, 0).getTime()
      }
      return 0
    },
    lastDay () {
      if (this.days[0]) {
        let y = new Date(this.days.slice(-1)[0] * 1000).getFullYear()
        let m = new Date(this.days.slice(-1)[0] * 1000).getMonth()
        let d = new Date(this.days.slice(-1)[0] * 1000).getDate() + 1
        return new Date(y, m, d, 0, 0, 0).getTime()
      }
      return 0
    },
    firstTime () { // 提前一天开启开幕式直播入口
      return this.firstDay - this.global.timestamp // this.days[0] * 1000 - this.global.timestamp
    },
    lastTime () {
      return this.firstDay + 13 * 60 * 60 * 1000 // this.firstDay + this.global.timestamp // this.days.slice(-1)[0] * 1000
    },
    // hasOpening () {
    //   return !!(
    //     (this.schedule && this.schedule.finishing && this.days && this.days[0]) &&
    //     (this.schedule.finishing[this.days[0]] && this.schedule.finishing[this.days[0]]['1am'].name.trim() === '开幕式')
    //   )
    // },
    liveMarkOpeningEnter () { // 开幕式直播入口关联直播页
      let sid = this.global.area_id
      // console.log(this.firstDay, this.firstTime, this.lastTime)
      return Boolean(sid < '4488' && this.theTime >= this.firstTime && this.theTime < this.lastTime)
    },
    liveMarkOpeningShow () { // 开幕式直播入口关联二维码弹框
      let sid = this.global.area_id
      // console.log(this.firstDay, this.firstTime, this.lastTime)
      return Boolean(sid >= '4488' && this.theTime >= this.firstTime && this.theTime <= this.lastTime)
    },
    liveMarkOpeningMsg () {
      let msg = ''
      let sid = this.global.area_id
      console.log(this.firstDay, this.firstTime, this.lastTime)
      if (sid >= '4488') {
        if (this.theTime <= this.lastTime) {
          msg = this.theTime <= this.firstDay ? '预约观看现场直播' : '观看现场直播'
        } else {
          msg = '扫码观看直播回放'
        }
      }
      return msg
    }
  },
  created () {
    this.sid = (this.$route.query && this.$route.query.sid) || this.global.area_id || ''
    this.id_list = (this.global.config && this.global.config[this.sid]) || {}
    this.year = this.id_list.year || ''
    this.getSubject()
  },
  watch: {
    schedule: {
      handler (_new, _old) {
        console.log('schedule--- ', _new, _old) // length
        if (_new && this.global.isObjectKeys(_new)) {
          this.days = ((_new.datas && Object.keys(_new.datas)) || []).sort() // 日期
          // this.time = (_new.timesData && Object.keys(_new.timesData)) || [] // 课程时间
          // this.firstTime = parseInt(this.days.sort()[0] || 0) * 1000
          // this.liveMark = false
          // let firstTime = this.firstTime - 24 * 60 * 60 * 1000 // 提前一日开启入口
          // // console.log(this.theTime, this.firstTime, endTime)
          // if (this.theTime >= firstTime) {
          //   this.liveMark = true
          //   let endTime = this.firstTime + 13 * 60 * 60 * 1000
          //   // if ([4488, '4488'].includes(this.sid)) {
          //   if (this.sid >= '4488') { // 启用官网直播的届次
          //     this.liveMarkOpeningShow = Boolean(this.theTime <= endTime)
          //     // this.liveMarkOpeningShow = true // 是否长期开放入口(提前预约/观看回放)? 》》》》》》
          //     this.liveMarkOpeningMsg = (this.theTime <= endTime) ? '预约观看现场直播' : '扫码观看直播回放'
          //   } else {
          //     this.liveMarkOpeningEnter = Boolean(this.theTime <= endTime)
          //   }
          // }
          // console.log('------ ', this.firstTime)
          // 获取课程和专题
          let sData = this.global.safeDeepClone(_new.datas || {})
          let gLength = []
          if (sData && this.global.isObjectKeys(sData)) {
            // console.log(1)
            let day = ''
            let group = []
            let timeKeys = []
            for (let d = 0; d < this.days.length; d++) {
              // console.log(2, d)
              day = this.days[d]
              group = _new.finishing && _new.finishing[day] && Object.keys(_new.finishing[day])
              if (group && group.length > 0) {
                gLength.push(Math.ceil(group.length / 2))
                // console.log('--- ', group)
                for (let period of ['am', 'pm']) {
                  // console.log(3, period)
                  if (sData[day][period] && typeof sData[day][period] === 'object') {
                    // console.log(sData[day][period])
                    timeKeys = Object.keys(sData[day][period])
                    for (let time of timeKeys) {
                      // console.log(4, time)
                      // console.log(day, period, time, sData[day][period][time], _new.finishing)
                      // console.log(sData[day][period][time])
                      for (let id = 1; id <= gLength[d]; id++) {
                        // console.log(day, period, time, id, sData[day][period][time], _new.finishing)
                        if (!sData[day][period][time][id]) {
                          sData[day][period][time][id] = '敬请期待'
                        }
                      }
                    }
                  }
                }
              }
            }
            // console.log(sData)
          }
          // 专题key及数目
          let pArr = []
          for (let i = 0; i < this.days.length; i++) {
            // console.log(5, 1, i)
            pArr.push([])
            let fkeys = Object.keys(_new.finishing[this.days[i]])
            for (let j = 0; j < fkeys.length; j++) {
              // console.log(5, 2, j)
              pArr[i].push(fkeys[j])
            }
          }
          this.periods = this.global.safeDeepClone(pArr) // 每日专题am*pm
          this.groupLength = this.global.safeDeepClone(gLength)
          this.scheduleData = this.global.safeDeepClone(sData)
          this.finishingData = this.global.safeDeepClone(_new.finishing || {})
          this.scheduleDataValid = Boolean(this.scheduleData && this.global.isObjectKeys(this.scheduleData))
          this.tips = this.scheduleDataValid ? '加载中···' : '敬请期待'
          // console.log('.')
          console.log('👌🏻', _new, this.scheduleData, this.scheduleDataValid)
          if (this.id_list['difference']) {
            this.getDifference()
          }
        }
      },
      // immediate: true,
      deep: true
    },
    subject: {
      handler (_new, _old) {
        // console.log('subject--- ', _new, _old)
        if (_new && typeof _new === 'object' && _new.length > 0) {
          if (this.sid === '1104') {
            // let schedule = {}
            let groupLength = 0
            let days = []
            let data = {}
            let finishing = {}
            let item = {}
            let times = ''
            let timesData = {}
            for (let i = 0; i < _new.length; i++) {
              item = _new[i]
              times += !times.includes(item.times) ? (item.times + ',') : ''
            }
            let timelist = times.slice(0, -1).split(',').map(time => {
              if (time && time.length > 0) {
                return time.length < 11 ? ('0' + time) : time
              }
            }).sort()
            times = [[], []]
            for (let arr of timelist) {
              timesData[arr.split('-')[0]] = arr.split('-')
              if (parseInt(arr.slice(0, 2)) < 12) {
                times[0].push(arr.split('-'))
              } else {
                times[1].push(arr.split('-'))
              }
            }
            for (let i = 0; i < _new.length; i++) {
              item = _new[i]
              groupLength = Math.max(groupLength, parseInt(item.groupId))
              if (item.date && !data[item.date]) {
                days.push(item.date)
                data[item.date] = {}
                finishing[item.date] = {}
                data[item.date]['am'] = {}
                data[item.date]['pm'] = {}
                i--
              } else {
                for (let arr of times[0]) {
                  data[item.date]['am'][arr[0]] = { time: arr }
                }
                for (let arr of times[1]) {
                  data[item.date]['pm'][arr[0]] = { time: arr }
                }
              }
            }
            let timeArr = []
            for (let day of days) {
              for (let i = 1; i <= groupLength; i++) {
                finishing[day][i + 'am'] = {}
                finishing[day][i + 'pm'] = {}
              }
              for (let i = 0; i < _new.length; i++) {
                item = _new[i]
                if (parseInt(item.date) === parseInt(day)) {
                  timeArr = item.times.split(',').map(time => {
                    if (time && time.length > 0) {
                      return time.length < 11 ? ('0' + time) : time
                    }
                  }).sort()
                  let obj1 = {
                    company: item.company || '',
                    date: item.date || '',
                    desc: item.description || '',
                    groupId: item.groupId,
                    groupName: item.name || '',
                    name: item.venueName || '',
                    position: item.position || '',
                    producers: item.producers || ''
                  }
                  if (timeArr[0][0] === 0 || timeArr[0][0] === '0') {
                    !finishing[day][item.groupId + 'am'].date
                      ? finishing[day][item.groupId + 'am'] = {...obj1, period: 'am'}
                      : finishing[day][parseInt(item.groupId) + 1 + 'am'] = {...obj1, period: 'am'}
                  } else {
                    !finishing[day][item.groupId + 'pm'].date
                      ? finishing[day][item.groupId + 'pm'] = {...obj1, period: 'pm'}
                      : finishing[day][parseInt(item.groupId) + 1 + 'pm'] = {...obj1, period: 'pm'}
                  }
                  for (let course of item.schedulingCourse) {
                    // console.log(day, i, item.groupId, course.startTime)
                    let obj2 = {
                      courseDesc: '',
                      courseId: course.courseid || '',
                      courseTitle: course.courseTitle || '',
                      lecturers: [{
                        company: course.company || '',
                        description: '',
                        lid: '',
                        name: course.name || '',
                        position: course.position || '',
                        realName: ''
                      }],
                      logo: null,
                      seo: null,
                      sid: item.sid || ''
                    }
                    if (data[day]['am'][course.startTime]) {
                      if (data[day]['am'][course.startTime][item.groupId]) {
                        data[day]['am'][course.startTime][parseInt(item.groupId) + 1] = obj2
                      } else {
                        data[day]['am'][course.startTime][item.groupId] = obj2
                      }
                    } else if (data[day]['am']['0' + course.startTime]) {
                      if (data[day]['am']['0' + course.startTime][item.groupId]) {
                        data[day]['am']['0' + course.startTime][parseInt(item.groupId) + 1] = obj2
                      } else {
                        data[day]['am']['0' + course.startTime][item.groupId] = obj2
                      }
                    } else if (data[day]['pm'][course.startTime]) {
                      if (data[day]['pm'][course.startTime][item.groupId]) {
                        data[day]['pm'][course.startTime][parseInt(item.groupId) + 1] = obj2
                      } else {
                        data[day]['pm'][course.startTime][item.groupId] = obj2
                      }
                    }
                  }
                }
              }
            }
            // console.log(groupLength, times, timesData, data, finishing)
            this.schedule = {datas: {...data}, finishing, timesData}
          } else if (this.sid > '1104') {
            this.getSchedule()
            if (this.opening === '') {
              // 获取推荐案例和开幕式
              this.getRecommend()
              this.getOpening()
              this.getCollectionInfos()
              if (this.id_list['opening']) {
                this.courses_index = -1
              }
              // menu渲染
              this.showMenu()
              window.addEventListener('resize', () => {
                if (this.$route.path && this.$route.path.includes('/schedule')) {
                  this.showMenu()
                }
              })
            }
          }
        }
      },
      // immediate: true,
      deep: true
    }
  },
  methods: {
    scrollSmoothTo: function (position) {
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback, element) {
          return setTimeout(callback, 17)
        }
      }
      // 当前滚动高度
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 滚动step方法
      var step = function () {
        // 距离目标滚动距离
        var distance = position - scrollTop
        // 目标滚动位置
        // console.log('scrollSmoothTo ', position, scrollTop, distance, document.body.offsetTop);
        scrollTop = scrollTop + distance / 5
        if (Math.abs(distance) < 1) {
          window.scrollTo(0, position)
        } else {
          window.scrollTo(0, scrollTop)
          requestAnimationFrame(step)
        }
      }
      step()
    },
    clickLi_: function (i) {
      this.pday = parseInt(i) || 0
      if (this.pday === 0) {
        this.scrollSmoothTo(document.getElementById('item1').offsetTop)
      } else if (this.pday === 1) {
        this.scrollSmoothTo(document.getElementById('item2').offsetTop)
        // this.scrollSmoothTo(document.getElementById('item2').getElementsByTagName('table')[0].offsetTop - this.global.header_height);
      }
    },
    showMenu: function () {
      // console.log('showMenu')
      let wWidth = window.innerWidth
      if (wWidth > 767) {
        let wHeight = window.innerHeight
        // eslint-disable-next-line no-undef
        $('#menu').css({ display: 'none' })
        // eslint-disable-next-line no-undef
        // $(window).scroll(() => {
        window.addEventListener('scroll', () => {
          // console.log('3-')
          if (this.$route.path && this.$route.path.includes('/schedule')) {
            // let s_top = document.body.scrollTop || document.getElementsByTagName('body').scrollTop || window.pageYOffset
            let headerHeight = document.getElementsByClassName('pc-wrapper')[0].offsetHeight
            let item2 = document.getElementById('item2')
            if (item2) {
              let h = item2.offsetTop - (wHeight - headerHeight)
              // eslint-disable-next-line no-undef
              if ($(window).scrollTop() > h) { // 1600
                // eslint-disable-next-line no-undef
                $('#menu').fadeIn(500)
                this.pday = 1
              } else {
                // eslint-disable-next-line no-undef
                $('#menu').fadeOut(500)
                this.pday = 0
              }
            }
          }
        })
      }
    },
    showDay: function (i, period) {
      this.mday = parseInt(i)
      this.mperiod = period
      if (this.isOpening(i, period)) {
        this.courses_index = -1
      } else {
        this.courses_index = 1
      }
    },
    showCourses: function (i) {
      this.courses_index = parseInt(i)
    },
    isLiveTime: function (type) {
      console.log(type)
      let flag = false
      if (!type || type === '' || type.includes('opening')) { // 开幕式直播时间
        // if (![4488, '4488'].includes(this.sid)) {
        if (this.sid < '4488') { // 启用官网直播的届次
          // 启用官网直播渠道(不需要回放,到时间直接关闭入口)
          let endTime = this.firstTime + 13 * 60 * 60 * 1000
          if (this.liveMark && (this.theTime <= endTime)) {
            flag = true
          }
        }
      }
      return flag
    },
    isLiveShow (type) {
      console.log(type)
      let flag = false
      if (!type || type === '' || type.includes('opening')) { // 开幕式直播时间
        // if ([4488, '4488'].includes(this.sid)) {
        if (this.sid < '4488') { // 启用官网直播的届次
          // 启用外部直播渠道引导(是否允许回放? 》》》》》》)
          // let endTime = this.firstTime + 13 * 60 * 60 * 1000
          // if (this.liveMark && (this.theTime <= endTime)) {
          //   flag = true
          // }
          if (this.liveMark) {
            flag = true
          }
        }
      }
      return flag
    },
    checkProducers (producers) {
      let str = producers
      if (typeof producers === 'string') {
        if (producers.includes('[') && JSON.parse(producers)) {
          producers = JSON.parse(producers)
          str = producers.join(' ')
        } else {
          str = producers
        }
      } else if (Array.isArray(producers)) {
        str = producers.join(' / ')
      }
      return str
    },
    checkCourseTime (day, times, pptStatus) {
      let thisTime = this.global.formatTime(this.theTime, 'Y.M.D-h:m', 2)
      let courseDay = this.global.formatTime(day, 'Y.M.D-')
      let startTime = courseDay
      let endTime = courseDay
      let startHour = ''
      let endHour = ''
      if (times[0] && times[0].length < 5) {
        times[0] = '0' + times[0]
      }
      if (times[1] && times[1].length < 5) {
        times[1] = '0' + times[1]
      }
      // 取课程开始和结束时间作为有效时间段
      if (times[0] && times[1]) {
        if (times[0] <= times[1]) {
          startTime += times[0]
          endTime += times[1]
          startHour = times[0]
          endHour = times[1]
        } else {
          startTime += times[1]
          endTime += times[0]
          startHour = times[1]
          endHour = times[0]
        }
      }
      if (!startTime.includes(':')) {
        startTime += '09:00'
        startHour = '09:00'
      }
      if (!endTime.includes(':')) {
        endTime += '17:50'
        endHour = '17:50'
      }
      // 取课程所在的半日时间作为有效时间，提前开放状态显示
      if (startHour < '12:00') {
        startTime = startTime.replace(startHour, '07:00')
        endTime = endTime.replace(endHour, '12:00')
      } else {
        startTime = startTime.replace(startHour, '12:30')
        endTime = endTime.replace(endHour, '17:50')
      }
      // 'off' 'on' 'wait'
      let status = (pptStatus && pptStatus !== '0') ? 'on' : 'off'
      if (thisTime < startTime) {
        status = 'wait'
      } else if (pptStatus && pptStatus !== '0') {
        status = 'on'
      } else {
        status = 'off'
      }
      // thisTime + ' ' + startTime + ' ' + endTime
      console.log(thisTime, [startTime, endTime], '--', times, status)
      return `ppt-status-${status}`
    },
    goLive: function () {
      // console.log('Live');
      // window.open('https://live.msup.com.cn/watch/2571879','_blank');
      const lUrl = this.formatHref('/live', {groupid: 9, time: this.days[0]})
      this.$router.push(lUrl)
    },
    showLive () {
      console.log('show live')
      // 》》》》》》
    },
    colClass: function (num) {
      return `col-lg-${num} col-md-${num} col-sm-${num} col-xs-${num}`
    },
    isOpening: function (day, period) {
      let flag = false
      if (this.id_list['opening'] && (day === 0 || day === '0') && period && period.includes('am')) {
        flag = true
      }
      return flag
    },

    // opening
    getOpening: function () {
      // console.log('开幕式判断开始……')
      this.opening = []
      this.openingList = []
      if (this.id_list['opening'] && parseInt(this.id_list['opening'])) {
        // console.log('opening 获取开始……', this.id_list['opening'])
        let url = `${this.global.urlNew.sue['all']}${this.id_list['opening']}`
        this.$http.jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            console.log('opening ', res)
            if (res.errno === '0' || res.errno === 0) {
              this.opening = (res.data && res.data[0]) || []
              this.openingList = res.data[0].map(item => {
                let iDesc = (item.desc && item.desc.toString().trim()) || ''
                let descMark = 
                  iDesc.includes('||') ? '||' : (
                    iDesc.includes('-') ? '-' : (
                      iDesc.includes(',') ? ',' : (
                        iDesc.includes('，')? '，' : '')))
                let lecMark = 
                  item.content.includes('||') ? '||' : (![4497, '4497'].includes(this.sid) ? (
                    item.content.includes('-') ? '-' : '') : '')
                return {
                  title: item.content_note,
                  lecturer: item.content ? (lecMark ? item.content.split(lecMark) : [item.content]) : '',
                  times: iDesc ? ((descMark) ? iDesc.split(descMark) : [iDesc]) : ['', ''],
                  time: iDesc
                }
              });
              this.openingList = this.openingList.sort(this.global.toSortKey('time',1,'string'))
              this.$forceUpdate()
            }
          })
      }
    },
    // recommend
    getRecommend: function (i) {
      console.log('推荐案例判断开始……')
      let recommendId = this.id_list['recommend'] && parseInt(this.id_list['recommend'])
      if (recommendId) {
        console.log('recommend 获取开始……', recommendId)
        let rurl = this.global.urlNew.sue['all'] + recommendId
        this.$http.jsonp(rurl)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            if (data.errno === '0' || data.errno === 0) {
              // console.log("recommend", data);
              this.recommend = data.data[0]
              this.$forceUpdate()
            }
          })
      }
    },
    // collectionInfos
    getCollectionInfos: function () {
      let infos = {}
      let url = this.global.urlNew['sue']['all'] + this.global.normalSueIDs['collection']
      this.$http.jsonp(url)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log('---', this.global.area_id, res && res.data)
          if (res.errno === 0 || res.errno === '0') {
            ((res.data || [])[0] || []).filter(item =>
              item.typeName && item.typeName.includes(this.global.area_id) && (item.content_note || item.title)
            ).forEach(item => {
              // console.log('collectionInfos ', item)
              if (item.content_note) {
                let openingAddress = item.content_note.split('，').filter(item => item && item.includes('开幕式'))[0]
                this.openingAddress = (openingAddress && openingAddress.split('-')[1]) || ''
              }
            })
          }
        })
    },

    // subject
    getSubject: function () {
      let surl = this.global.urlNew.subject + this.sid
      this.$http.jsonp(surl)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log('subject ', res)
          if (res.errno === '0' || res.errno === 0) {
            this.subject = res.data
          }
        })
    },
    toSubjectDetail: function (schedule) {
      if (this.sid !== '4288') {
        let date = schedule.date
        let groupId = schedule.groupId
        let venueName = schedule.name
        let id = false
        for (let item of this.subject) {
          if (
            (parseInt(item.date || 0) === parseInt(date || 0)) &&
            (item.groupId === groupId || parseInt(item.groupId) === parseInt(groupId)) &&
            (item.venueName === venueName || (typeof item.venueName === 'string' && typeof venueName === 'string' && item.venueName.trim() === venueName.trim()))
          ) {
            id = item.id
          }
        }
        if (id) {
          const sUrl = this.formatHref('/subject-detail', { vid: id })
          this.$router.push(sUrl)
        }
      }
    },

    // schedule
    getSchedule: function () {
      console.log('schedule 获取开始……')
      var url = this.global.urlNew.schedule_final + this.sid
      this.$http.jsonp(url)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log("schedule ", res);
          if ((res.errno === 0 || res.errno === '0') && res.data && res.data.datas) {
            var schedule = {...res.data}
            const days = Object.keys(schedule.finishing || {})
            for (let day of days) {
              let groups = Object.keys(schedule.finishing[day])
              for (let group of groups) {
                if (!(
                  schedule.finishing[day][group] &&
                  schedule.finishing[day][group].producers &&
                  schedule.finishing[day][group].producers.length > 0
                )) {
                  for (let subject of this.subject || []) {
                    if (
                      (subject.date || '').toString() === (day || '').toString() &&
                      (subject.venueName || '').toString() === (schedule.finishing[day][group].name || '').toString()
                    ) {
                      schedule.finishing[day][group].producers = (subject.producers || subject.name || '').split(',')
                      break
                    }
                  }
                }
              }
            }
            this.schedule = {...schedule}
          } else {
            this.tips = '敬请期待'
          }
        })
        .catch(err => {
          console.log(err)
          this.tips = '敬请期待'
        })
    },
    getWeek: function (item) {
      var date = new Date(item * 1000) // 接口获取的数据一般为时间戳的1/1000
      let num = date.getDay()
      switch (num) {
        case 0:
          return '星期日'
          // break
        case 1:
          return '星期一'
          // break
        case 2:
          return '星期二'
          // break
        case 3:
          return '星期三'
          // break
        case 4:
          return '星期四'
          // break
        case 5:
          return '星期五'
          // break
        case 6:
          return '星期六'
          // break
        default:
          break
      };
    },
    getCourseLength: function () {
      if (this.year && this.year.includes('2018')) {
        return 23
      } else {
        return this.id_list['opening']
          ? (this.time.length * this.periods.length - 3) * this.periods[0].length / 2
          : this.time.length * this.periods.length * this.periods[0].length / 2
      }
    },

    // ppt
    getPPTManage (goodsId) {
      // console.log('get_PPT_Manage__', goodsId)
      this.pptGoodsId = goodsId || ''
    },
    getPPTLink (link) {
      this.pptLink = link || null
    },

    // 特殊排课
    reVenueId (vname) {
      // console.log('特殊排课：', vname, this.subject)
      let id = ''
      for (let item of this.subject) {
        if (item.venueName.trim() === (vname || '').trim()) {
          id = item.id
          break
        }
      }
      return id
    },
    getGroupKey (dayIndex, groupId, period) {
      return `${this.year}_${parseInt(dayIndex) + 1}_${groupId}_${period}`
    },
    getDifference () {
      if (this.id_list['difference'] && parseInt(this.id_list['difference'])) {
        let url = this.global.urlNew.sue['type'] + this.id_list['difference']
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log('difference ', res)
            if ([0, '0'].includes(res.errno) && res.data) {
              let type = ''
              let typeList = []
              for (let item of res.data) {
                type = item.typeName && typeof item.typeName === 'string' && item.typeName.toLocaleLowerCase()
                if (type && type.includes('mpd') && type.includes(this.year)) {
                  typeList.push({ id: item.id, name: type.split('#')[1], clauseActivityId: type.split('#')[2] || '' })
                }
              }
              this.getScheduleDifference(typeList)
            }
          })
      }
    },
    getScheduleDifference (typeList) {
      // {'2024sz_1_6_pm':{ length:6, courses:[], linkUrl:'https://www.msup.com.cn/site/clause-activity?id=3784' }}
      if (typeList.length > 0) {
        // 初始化数据结构
        let difference = {}
        for (let type of typeList) {
          difference[type.name] = { length: 0, courses: [], linkUrl: '' }
          if (type.clauseActivityId) {
            difference[type.name].linkUrl = `https://www.msup.com.cn/site/clause-activity?id=${type.clauseActivityId}`
          }
          if (type.name.includes('am')) {
            difference[type.name].length = 3
          } else if (type.name.includes('pm')) {
            difference[type.name].length = 4
          }
          this.$forceUpdate()
        }
        // 获取数据
        let url = this.global.urlNew.sue['arr'] + this.id_list['difference']
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            if ([0, '0'].includes(res.errno) && res.data && res.data[0] && res.data[0].length > 0) {
              // console.log('difference ', res.data[0])
              for (let typeItem of typeList) {
                if (difference[typeItem.name]) {
                  difference[typeItem.name].courses = []
                  difference[typeItem.name].timeStamp = new Date().getTime()
                  // let course = {}
                  let lecturers = []
                  let lecturer = ''
                  let times = []
                  // let titles = []
                  // let title = ''
                  for (let index in res.data[0]) {
                    let course = res.data[0][index]
                    // if (course.detailType.toString().trim() === '281') {
                    if (course.detailType.toString().trim() === typeItem.id.toString().trim()) {
                      lecturers = course.content && course.content.length > 0 && course.content.split(' /// ')
                      if (course.content_note && course.content_note.length > 0) {
                        times = (course.content_note.split('scheduleTitle--')[0] || '').replace('time--', '').replace(/\r\n/g, '').split('-')
                        // titles = (course.content_note.split('scheduleTitle--')[1] || '').replace(/^\r\n/, '').split('\r\n')
                      }
                      difference[typeItem.name].courses.push({
                        courseId: (course.title && course.title.split('||') && course.title.split('||')[1]) || '',
                        courseTitle: (course.title && course.title.split('||') && course.title.split('||')[0]) || '敬请期待',
                        lecturers: [],
                        times: times
                      })
                      let cIndex = difference[typeItem.name].courses.length - 1
                      for (let lindex in lecturers) {
                        lecturer = lecturers[lindex] || ''
                        // title = titles[lindex] || '';
                        if (lecturer.split(' || ')[0] && lecturer.split(' || ')[0].trim() !== '客户技术高层') {
                          difference[typeItem.name].courses[cIndex].lecturers.push({
                            name: lecturer.split(' || ')[0] || '',
                            company: lecturer.split(' || ')[1] || '',
                            position: lecturer.split(' || ')[2] || ''
                            // courseTitle: title, // 不需要显示讲师议题
                          })
                        }
                      }
                    }
                  }
                  difference[typeItem.name].length = difference[typeItem.name].courses.length || difference[typeItem.name].length
                }
              }
              this.scheduleDifference = difference
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
#app #schedule {
  p{
    margin: 0;
    padding: 0;
  }
  a,a:hover,a:visited {
    color: #000000!important;
    text-decoration: none!important;
  }
  // div
  h1,h2,h3,h4,h5,h6,p,a,span,b,i,em {
    // font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    //   Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    //   sans-serif;
    margin: 0;
  }

  div[class*='ppt-status'] {
    position: absolute;
    bottom: 10px;
    left: 14px;
  }
  div[class*='ppt-status'], span[class*='ppt-status'] {
    width: 36px;
    height: 20px;
    padding-right: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    --status-text-color: #000000;
    --status-border-color: #000000;
    --status-line-color: #000000;
    border: var(--status-border-color) 2px solid;
    border-radius: 36px;
    opacity: 1;
    i {
      font-size: 13px;
      color: var(--status-text-color);
    }
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 2px;
      position: absolute;
      transform: rotate(30deg);
      background-color: var(--status-line-color);
    }
    &[class*='wait'] {
      --status-text-color: #d5d5d5;
      --status-border-color: #d5d5d5;
      --status-line-color: transparent;
    }
    &[class*='on'] {
      opacity: 0.6;
      --status-text-color: var(--main-bgcolor);
      --status-border-color: var(--main-bgcolor);
      --status-line-color: transparent;
    }
    &[class*='off'] {
      --status-text-color: #bfbfbf;
      --status-border-color: #ff000080;
      --status-line-color: #ff000080;
    }
  }

  .con.schedule_con {
    width: 100%;
    // max-width: 1440px;
    max-width: 1260px;
    margin-bottom: 60px;
    .schedule_null {
      width: 100%;
      font-size: 20px;
      text-align: center;
      margin-top: 90px;
      margin-bottom: 90px;
      padding-top: 20px;
    }
    #menu {
      width: auto;
      position: fixed;
      z-index: 201;
      bottom: 50px;
      right: 10px;
      margin-left: 400px;
      &.has-ppt-goods {
        bottom: 120px;
      }
      ul {
        li {
          a {
            display: block;
            border: 1px solid #0088bb;
            margin: 5px 0;
            font-size: 14px;
            font-weight: bold;
            color: #333;
            width: 80px;
            height: 50px;
            line-height: 50px;
            text-decoration: none;
            text-align: center;
            &:hover, &.current {
              border: 1px solid var(--main-bgcolor);
              color: #ffffff!important;
              background: var(--main-bgcolor);
            }
          }
        }
      }
    }
    .menu {
      width: auto;
      position: fixed;
      bottom: 80px;
      right: 10px;
      z-index: 99;
    }
    .richeng {
      // max-width: 1440px;
      max-width: 1260px;
      margin: 0 auto;
      margin-top: 100px;
      .daohang {
        width: 80%;
        margin: 0 auto;
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        justify-content: center;
        li {
          text-align: center;
          float: left;
          height: 100px;
          a {
            color: #000000;
          }
          div {
            margin: 0 auto;
            width: 80%;
            text-align: center;
            height: 100px;
            border: 1px solid var(--main-bgcolor);
            transition: all 0.3s;
            cursor: url("../assets/img/images/mouse3.png"), auto;
          }
          div:hover {
            background: var(--main-bgcolor);
            // opacity: 0.8;
            color: #ffffff;
            h1, span {
              color: #ffffff;
            }
          }
          h1 {
            margin: 0;
            font-weight: 500;
            padding-top: 25px;
            font-size: 36px;
          }
          span {
            font-size: 14px;
            white-space: pre;
          }
        }
        .active {
          div {
            color: #ffffff;
            background: var(--main-bgcolor);
            h1, span {
              color: #ffffff;
            }
            span {
              font-weight: 500;
            }
          }
        }
      }
      .content {
        // max-width: 1300px;
        margin: 0 auto;
        li {
          h4 {
            text-align: center;
            margin-top: 20px;
            margin-bottom: 20px;
            padding-top: 100px;
            padding-bottom: 50px;
            font-size: 40px;
            font-weight: 500;
          }
          table {
            border-collapse: collapse;
            border-spacing: 0;
            --group-length: 5;
            --time-width: 75px;
            .top {
              td {
                width: 10%;
                height: 95px;
                min-width: calc((768px - var(--time-width)) / var(--group-length));
                color: #FFFFFF;
                // padding-left: 14px;
                padding-left: 8px;
                background-color: var(--main-bgcolor);
                border: 1px solid #dddddd;
                border-right: none;
                border-bottom: none;
                font-size: 20px;
                // font-weight: bold;
                a {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: flex-start;
                  align-content: flex-start;
                  align-items: flex-start;
                }
                .group-name {
                  width: 100%;
                  min-height: 48px;
                  line-height: 24px;
                  margin-top: 8px;
                  margin-bottom: 3px;
                  color: #FFFFFF;
                }
                .chup {
                  width: 100%;
                  font-size: 15px;
                  color: #FFFFFF;
                  &.company {
                    line-height: 18px;
                    display: inline-block;
                    margin-top: 4px;
                    color: #eee;
                    // & + .company {
                    //   margin-top: 2px;
                    // }
                    &:nth-last-of-type(1) {
                      padding-bottom: 4px;
                    }
                  }
                }
                &.time-title {
                  width: 7%;
                  height: 95px;
                  min-width: var(--time-width);
                  max-width: 120px;
                  padding: 10px 5px;
                  position: relative;
                  a {
                    width: 100%;
                    height: 75px;
                    max-width: var(--time-width);
                    display: flex;
                    justify-content: center;
                    align-content: space-between;
                    align-items: start;
                    flex-wrap: wrap;
                    position: relative;
                  }
                  span {
                    width: 100%;
                    // // width: 86px;
                    // width: 90px;
                    height: fit-content;
                    line-height: 1;
                    font-size: 16px;
                    font-weight: 500;
                    padding: 0;
                    text-align: left;
                    color: rgba(255, 255, 255, 1);
                    display: block;
                    // position: absolute;
                    &.fenhuichang {
                      text-align: right;
                      padding-top: 10px;
                      transform: translateX(6px) translateY(2px);
                      // padding-top: 27px;
                      // right: 50%;
                      // transform: translateX(50%);
                    }
                    &.shijian {
                      text-align: left;
                      padding-bottom: 12px;
                      padding-left: 3px;
                      // padding-bottom: 26px;
                      // left: 50%;
                      // transform: translateX(-50%);
                      // margin-left: 3px;
                    }
                    &.line {
                      width: 81px;
                      height: 1px;
                      background-color: rgba(255, 255, 255, 1);
                      box-shadow: 0px 0px 1px rgba(255, 255, 255, 1);
                      transform: translateX(-3px) translateY(2px) rotateZ(45deg);
                      // top: 50%;
                      // left: 50%;
                      // transform: translateX(-50%) translateY(50%) rotateZ(45deg);
                      // margin-left: -5px;
                    }
                  }
                }
                &.opening-title {
                  padding-left: 0;
                }
                &:last-child {
                  // border-right: 1px solid #dddddd;
                  border-right: 1px solid var(--main-bgcolor);
                }
              }
              &.s-4288, &.s-4535 {
                td {
                  &.time-title {
                    width: 3%;
                  }
                }
              }
              &.s-4488, &.s-4535 {
                td {
                  .tolive {
                    margin-top: -5px !important;
                    &.tool-tip {
                      margin-top: -3px !important;
                    }
                  }
                }
              }
              &.s-4488 {
                td {
                  font-size: 15px;
                  .group-name {
                    font-size: 15px;
                    line-height: 18px;
                  }
                  .chup {
                    font-size: 13px;
                  }
                  &.time-title {
                    span {
                      font-size: 14px;
                    }
                  }
                }
              }
              &.s-4535 {
                td {
                  font-size: 16px;
                  .group-name {
                    font-size: 16px;
                    line-height: 18px;
                  }
                  .chup {
                    font-size: 14px;
                  }
                  &.time-title {
                    span {
                      font-size: 15px;
                    }
                  }
                }
              }
              &.opening {
                td {
                  line-height: 35px;
                  padding: 0;
                  text-align: center;
                  position: relative;
                }
              }
            }
            .kecheng {
              td {
                width: 10%;
                border: 1px solid #dddddd;
                border-right: none;
                border-bottom: none;
                background: #fafbfc;
                text-align: left;
                font-size: 14px;
                color: #333;
                &.course-href {
                  padding-bottom: 25px;
                  position: relative;
                  cursor: url("../assets/img/images/mouse3.png"), auto;
                  &:hover:not(.difference) {
                    transition: all .3s;
                    background-color: var(--main-bgcolor);
                    * {
                      color: #ffffff!important;
                    }
                    .cornermark {
                      border-top-color: #48a3d8;
                    }
                  }
                  &.blank {
                    padding: 0;
                    &:hover {
                      color: #ffffff;
                    }
                    a {
                      padding: 0;
                      text-align: center;
                    }
                  }
                  &.difference {
                    padding-bottom: 0;
                    vertical-align: top;
                    .d-con {
                      width: 100%;
                      height: 100%;
                      // display: grid;
                    }
                    .d-item {
                      width: 100%;
                      height: 100%;
                      border: none;
                      &:nth-of-type(1), &:nth-of-type(1) td {
                        border-top: none;
                      }
                      &:nth-last-of-type(1), &:nth-last-of-type(1) td {
                        border-bottom: none;
                      }
                    }
                    .d-item-detail {
                      width: 100%;
                      height: 100%;
                      border-left: none;
                      border-right: none;
                    }
                  }
                  a {
                    width: 100%;
                    height: 100%;
                    display: block;
                    // padding-left: 14px;
                    padding-left: 10px;
                    position: relative;
                  }
                  &:hover div[class*='ppt-status'] {
                    --status-text-color: #ffffff;
                    --status-border-color: #ffffff;
                    --status-line-color: #ffffff;
                    &[class*='wait'] {
                      opacity: 0.3;
                      --status-line-color: transparent;
                    }
                    &[class*='on'] {
                      opacity: 1;
                      --status-line-color: transparent;
                    }
                    &[class*='off'] {
                      opacity: 1;
                      --status-border-color: #ffffffb5;
                    }
                  }
                }
                .biaoti_s {
                  width: 100%;
                  // height: 126px;
                  min-height: 100px;
                  line-height: 26px;
                  font-size: 18px;
                  // color: #1f63af;
                  // padding: 25px 10px 0 0;
                  // margin-bottom: 25px;
                  padding: 20px 10px 0 0;
                  margin-bottom: 20px;
                  // word-break: break-all;
                  // word-wrap: break-word;
                  // display: -webkit-box;
                  // -webkit-box-orient: vertical;
                  // -webkit-line-clamp: 3;
                  // text-overflow: ellipsis;
                  // overflow: hidden;
                }
                .ren {
                  width: 100%;
                  // height: 90px;
                  // padding-bottom: 25px;
                  padding-bottom: 20px;
                  h2 {
                    font-size: 16px;
                    color: #333333;
                    font-weight: 700;
                    // font-weight: bold;
                    // margin-top: 10px;
                    // margin-bottom: 0;
                  }
                  p {
                    line-height: 1.4;
                    font-size: 16px;
                    color: #666666;
                    padding-top: 10px;
                    // margin-bottom: 0;
                  }
                }
                &:first-child:not(.d-item-detail) {
                  width: 105px;
                  height: 180px;
                  font-size: 16px;
                  color: #000000;
                  text-align: center;
                  line-height: 24px;
                  padding-left: 0;
                }
                &:last-child {
                  border-right: 1px solid #dddddd;
                }
              }
              &.opening {
                td {
                  height: auto;
                  padding: 15px 0;
                  text-align: center;
                  &:first-child {
                    height: auto;
                  }
                  .biaoti_s {
                    height: auto;
                    min-height: auto;
                    margin-bottom: 0;
                    padding-top: 0;
                  }
                  .ren {
                    padding-bottom: 0;
                    h2 {
                      margin-top: 15px;
                    }
                    p {
                      line-height: 20px;
                      padding-top: 10px;
                    }
                  }
                }
              }
            }
            tr{
              &.link-url {
                @keyframes blink {
                  0% {
                    opacity: 1;
                    background-color: var(--main-bgcolor);
                  }
                  50% {
                    opacity: .9;
                    background-color: #00a0dc;
                  }
                  100% {
                    opacity: 1;
                    background-color: var(--main-bgcolor);
                  }
                }
                padding: 0;
                height: 40px;
                min-height: 40px;
                td.course-href {
                  padding: 0;
                  height: 40px;
                  min-height: 40px;
                  text-align: center;
                  animation: blink 2.8s ease infinite;
                  a, a:focus, a:hover, a:visited {
                    padding: 0;
                    line-height: 40px;
                    font-weight: 700;
                    text-align: center;
                    color: #fff!important;
                  }
                }
              }
              &:last-child {
                border-bottom: 1px solid #dddddd;
              }
            }
          }
        }
      }
      &.mob {
        margin-top: 15px;
        ul.daohang {
          width: 100%;
          li {
            height: auto;
            min-width: 0;
            padding-left: 5px;
            padding-right: 5px;
            border: 1px solid #0b70a4;
            h1 {
              padding: 0;
              color: var(--main-bgcolor);
              font-size: 20px;
              // font-weight: 400;
              // line-height: 55px;
              line-height: 45px;
              display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
              display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
              display: -ms-flexbox;  /* TWEENER - IE 10 */
              display: -webkit-flex; /* NEW - Chrome */
              display: flex;
              justify-content: center;
              span {
                color: var(--main-bgcolor);
                font-size: 12px;
                padding-top: 3px;
                // padding-top: 24px;
                display: block;
              }
            }
            &.active {
              background: var(--main-bgcolor);
              h1 {
                color: #FFFFFF;
              span {
                color: #FFFFFF;
              }
              }
            }
            &:not(:nth-of-type(1)) {
              border-left: none;
            }
          }
        }
        .content.content_smob {
          ul.day_menu {
            margin-top: 20px;
            padding: 0 10px;
            li {
              float: left;
              width: auto;
              height: auto;
              min-height: 36px;
              padding-left: 15px;
              padding-right: 15px;
              margin-bottom: 10px;
              margin-left: 5px;
              margin-right: 5px;
              border: 1px solid var(--main-bgcolor);
              border-radius: 20px;
              color: #337ab7;
              background: #ffffff;
              * {
                color: #337ab7;
                background: #ffffff;
                margin: 0;
                padding: 0;
              }
              h1 {
                height: 34px;
                line-height: 34px;
                font-size: 14px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                line-clamp: 1;
                -webkit-line-clamp: 1;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              p {
                line-height: 1;
                margin-top: -6px;
                padding-bottom: 5px;
                font-size: 12px;
                font-weight: 400;
                i {
                  font-size: 10px;
                  margin-right: 3px;
                }
              }
              &.active {
                background: var(--main-bgcolor);
                color: #ffffff;
                * {
                  background: var(--main-bgcolor);
                  color: #ffffff;
                }
              }
            }
          }
          ul.day_list{
            margin-top: 10px;
            // display: none;
            li{
              width: 100%;
              // padding: 20px 15px 50px 15px;
              padding: 20px 15px 30px 15px;
              margin: 0 auto;
              margin-bottom: 10px;
              background: #ffffff;
              &:not(:nth-last-of-type(1)) {
                border-bottom: 1px solid #ededed;
              }
              // &.difference {
              //   padding: 20px 15px 30px 15px;
              //   // margin-bottom: 0;
              // }
              h1{
                line-height: 24px;
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 10px;
              }
              p{
                line-height: 20px;
                padding-top: 5px;
                // margin-left: 15px;
                &:nth-last-of-type(1) {
                  padding-top: 10px;
                  display: flex;
                  justify-content: flex-start;
                  align-content: flex-start;
                  align-items: center;
                }
                &:nth-of-type(1){
                  span{
                    font-size: 16px;
                  }
                }
                span{
                  margin-right: 5px;
                  // font-weight: 500;
                  &[class*='ppt-status'] {
                    margin-left: 15px;
                    position: relative;
                  }
                }
              }
              &.islive {
                margin-bottom: 0;
                padding-top: 0;
                padding-bottom: 0;
                border-bottom: none;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    // margin-top: 0;
    .pc_content{
      padding: 0 2%;
      .con.schedule_con{
        margin-bottom: 10px;
      }
    }
  }
}
// @media (max-width: 1023px) {
//   #schedule{
//     margin-top: 0;
//   }
// }

// 角标
.cornermark {
  width: 45px;
  height: 45px;
  position: absolute;
  top: 0;
  right: 0;
  border-top: 45px solid var(--main-bgcolor);
  border-left: 45px solid transparent;
  p {
    position: absolute;
    top: -45px;
    right: 0;
    width: 30px;
    height: 33px;
    line-height: 30px;
    padding: 0!important;
    font-size: 12px!important;
    font-weight: 500!important;
    text-align: center;
    color: #FFFFFF!important;
    transform: rotate(45deg);
  }
}

// 直播间按钮
.tolive {
  border: none !important;
  border-radius: 20px !important;
  color: var(--main-bgcolor) !important;
  margin-top: -8px !important;
  margin-left: 50px !important;
  padding: 8px 25px !important;
  position: absolute !important;
  text-align: center !important;
  background: #ffffff !important;
}
.tolive_mob {
  // margin-top: 14px;
  margin-top: 0 !important;
  margin-bottom: 14px !important;
  padding: 0 15px !important;
  // line-height: 30px;
  float: right;
  // border: none;
  // border: 1px solid #aaaaaa;
  // border-radius: 5px;
  width: auto !important;
  height: 36px !important;
  line-height: 34px !important;
  font-size: 14px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  color: var(--main-bgcolor) !important;
  border-radius: 20px !important;
  // border: 1px solid var(--main-bgcolor);
  border: none !important;
  background-color: #ffffff !important;
}
.tolive-code {
  text-align: center;
  img.code {
    width: 100px;
    height: auto;
    margin: 5px 0;
  }
  .text {
    line-height: 1.4;
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Schedule.vue